<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane name="first" label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{improvedSurvey.billNo}}</td>
            <td class="tableLabel">反馈人：</td>
            <td>{{improvedSurvey.creatorName}}</td>
            <td class="tableLabel">投诉日期：</td>
            <td>{{improvedSurvey.complaintDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">序列号：</td>
            <td>{{improvedSurvey.serialNo}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{improvedSurvey.factoryNo}}</td>
            <td class="tableLabel">发生阶段：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.stage" disabled placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.stage)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">客户名称：</td>
            <td>{{improvedSurvey.customerName}}</td>
            <td class="tableLabel">提交时间：</td>
            <td>{{improvedSurvey.submitTime}}</td>
            <td class="tableLabel">联系方式：</td>
            <td>{{improvedSurvey.contact}}</td>
          </tr>
          <tr>
            <td class="tableLabel">问题描述：</td>
            <td colspan="5">{{improvedSurvey.problemDesc}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="second" label="cqe初审">
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">基准：</td>
            <td>
              {{improvedSurvey.standard}}
            </td>
            <td class="tableLabel">实际：</td>
            <td>
              {{improvedSurvey.practical}}
            </td>
          </tr>
          <tr>
            <td class="tableLabel">投诉性质：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintNature" disabled placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintNature)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">产品大类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.productType" disabled placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.productType)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">调查结果：</td>
            <td>
              {{improvedSurvey.surveyResult}}
            </td>
            <td class="tableLabel">责任划分：</td>
            <td>
              <div>
                <el-radio-group v-model="improvedSurvey.dutyType" disabled>
                  <el-radio :label="1">新时达责任</el-radio>
                  <el-radio :label="2">供应商责任</el-radio>
                  <el-radio :label="3">客户责任</el-radio>
                </el-radio-group>
              </div>
              <div style="margin-top: 1%">
                <el-input
                    v-if="improvedSurvey.dutyType===1"
                    v-model="improvedSurvey.dutyValue"
                    disabled
                    style="width: 50%"
                    placeholder="请输入责任部门"/>
                <el-input
                    v-else-if="improvedSurvey.dutyType===2"
                    v-model="improvedSurvey.dutyValue"
                    disabled
                    style="width: 50%"
                    placeholder="请输入供应商"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否重复问题：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isRepeatQuestion"
                    disabled
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">质量成本：</td>
            <td>
              {{improvedSurvey.qualityCost}}
            </td>
          </tr>
          <tr>
            <td class="tableLabel">错误分类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.errorClassification" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.errorClassification)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">投诉等级：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintGrade" placeholder="请选择投诉等级">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintGrade)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">围堵措施：</td>
            <td>
              {{improvedSurvey.interceptMeasure}}
            </td>
            <td class="tableLabel">责任人/期限：</td>
            <td>
              <div>
                <el-input v-model="improvedSurvey.interceptHandelName" disabled style="width: 50%" placeholder="请输入"/>
                /
                <el-date-picker
                    v-model="improvedSurvey.allottedTime"
                    disabled
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    placeholder="选择日期"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否改进：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isImproved"
                    disabled
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">改进负责人：</td>
            <td>
              {{improvedSurvey.improvedHandelName}}
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="third" label="改进措施">
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">改进描述：</td>
            <td>
              {{improvedSurvey.improvedNote}}
            </td>
            <td class="tableLabel">改进责任人：</td>
            <td>
              {{improvedSurvey.improvedMeasureName}}
            </td>
          </tr>
        </table>
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
        </el-table>
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          举一反三
        </div>
        <el-table :data="improvedSurvey.detailVOS2">
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="dutyName" align="center" label="责任人"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="改进措施提交">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="creatorName" align="center" label="上传人"/>
          <el-table-column prop="fileNote" align="center" label="附件说明"/>
          <el-table-column prop="filePath" align="center" label="图片">
            <template slot-scope="scope">
              <img style="width: 50px;height: 50px" :src="scope.row.filePath" alt="" @click="bigImg(scope.row.filePath)">
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 1%">
          首单执行时间：
          <el-date-picker
              v-model="improvedSurvey.firstOrderTime"
              disabled
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"/>
        </div>
      </el-tab-pane>
      <el-tab-pane name="five" label="改进措施验证">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="fileNote" align="center" label="附件说明"/>
          <el-table-column prop="identifier" align="center" label="验证人"/>
          <el-table-column prop="verificationResult" align="center" label="是否通过">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.verificationResult"
                  active-color="#13ce66"
                  inactive-color="#9a9999"/>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="six" label="首单验证">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="fileNote" align="center" label="附件说明"/>
          <el-table-column prop="identifier2" align="center" label="验证人"/>
          <el-table-column prop="verificationResult2" align="center" label="是否通过">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.verificationResult2"
                  active-color="#13ce66"
                  inactive-color="#9a9999"/>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
      <el-table
          :data="improvedSurvey.materialList">
        <el-table-column prop="materialNo" align="center" label="物料编号"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="quantity" align="center" label="数量"/>
        <el-table-column prop="note" align="center" label="备注"/>
      </el-table>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="improvedSurvey.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        @closeClick="photoVisible = false"/>
  </div>
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import VmUploadFile from "@/components/VmUploadFile";
  import BigImg from "@/components/BigImg";
  import auth from "@/util/loginUtil";
  export default {
    name:"",
    components:{BigImg, HandleDetail},
    data() {
      return {
        activeName: "first",
        billId:"",
        imgUrls: [],
        billType:"28",
        pkid:"",
        improvedSurvey:{
        },
        constant,
        uploadLoading: false,
        photoVisible: false,
        bigImgUrl: "",
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.pkid = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.pkid = "";
      this.improvedSurvey={};
    },
    methods:{
      downLoad(row) {
        if(row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
      bigImg(url) {
        this.photoVisible = true;
        this.bigImgUrl = url;
      },
      getData() {
        this.$http.get("basic",`improvedSurveys/${this.billId}`).then((res)=>{
          console.log(res);
          this.improvedSurvey = res;
          this.improvedSurvey.attachments.forEach(row=>{
            if(row.filePath.includes("common")) {
              row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
              this.imgUrls.push(row.imgUrl);
            }else {
              row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
              this.imgUrls.push(row.imgUrl);
            }
          });
        }).catch(()=>{
        });
      },
    },
  };
</script>

<style lang="scss">
  table.ProjectOrderTable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  table.ProjectOrderTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProjectOrderTable td {
    padding: 8px;
    border-right: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
</style>
